import { Component, NgModule } from '@angular/core';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { MatIconModule, MatIcon } from '@angular/material/icon';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'uw-scheduled-email-delete-confirmation-dialog',
    templateUrl: './scheduled-email-delete-confirmation-dialog.component.html',
    styleUrls: ['./scheduled-email-delete-confirmation-dialog.component.scss'],
    imports: [A11yModule, MatIconButton, MatDialogClose, MatIcon, TranslateModule]
})
export class ScheduledEmailDeleteConfirmationDialogComponent {

  constructor(
    private readonly _dialogRef: MatDialogRef<ScheduledEmailDeleteConfirmationDialogComponent>
  ) { }

  confirm() {
    this._dialogRef.close(true);
  }
}

@NgModule({
    exports: [
        ScheduledEmailDeleteConfirmationDialogComponent
    ],
    imports: [
        A11yModule,
        CommonModule,
        MatDialogModule,
        MatIconModule,
        MatButtonModule,
        TranslateModule,
        ScheduledEmailDeleteConfirmationDialogComponent
    ]
})
export class ScheduledEmailDeleteConfirmationDialogModule { }
